import React, { useState, useEffect } from "react";
import { MDBDataTable } from "mdbreact";
// import AddFeedbackModal from "../ModalImpl/AddFeedbackModal";
import axios from "axios";
import toast, { Toaster } from "react-hot-toast";
import AddFeedbackModal from "../ModalImpl/AddFeedbackModal";
import Swal from "sweetalert2";
import Tooltip from "../DetailsPages/BranchDashboard/TicketServedDetails";
import TooltipM from '@mui/material/Tooltip';

const FeedbackPage = () => {
  const baseUrl = localStorage.getItem("API_URL");
  const token = localStorage.getItem("user_token");
  const userDetails = JSON.parse(localStorage.getItem("user_details"));

  const [showAddFeedbackModal, setShowAddFeedbackModal] = useState(false);
  const [modalType, setmodalType] = useState(); // 0-add, 1-edit
  const [selectedRow, setSelectedRow] = useState({});

  const [allFeedbackList, setAllFeedbackList] = useState([]);
  const [searchFeedbackText, setSearchFeedbackText] = useState("");
  const [allFeedbackForRender, setAllFeedbackForRender] = useState([]);
  const [allFeedbackTableBody, setAllFeedbackTableBody] = useState([]);

  // tableData
  const tableData = {
    columns: [
      {
        label: "#",
        field: "index",
        width: 10,
      },
      // {
      //   label: "",
      //   field: "status",
      // },
      {
        label: "Name",
        field: "name",
        width: 200,
      },
      {
        label: "Image",
        field: "image",
        width: 200,
      },
      {
        label: "Feedback Score",
        field: "score",
      },
      {
        label: "Action",
        field: "action",
        width: 0,
      },
    ],
    rows: allFeedbackTableBody.map((item) => ({
      ...item,
      status: item.masterFeedback ?
          <div style={{textAlign:'right'}}>
            <TooltipM title="Public Feedback">
              <i className="fa fa-globe text-info hover-icon-fg"></i>
            </TooltipM>
          </div> : <div></div>,
    })),
  };

  // call getRollWithPermissions - useEffect
  useEffect(() => {
    if (
      token !== null &&
      userDetails !== null &&
      showAddFeedbackModal === false
    ) {
      if (
        baseUrl.length > 0 &&
        token.length > 0 &&
        Object.keys(userDetails).length > 0
      ) {
        getFeedbackList();
      }
    }
  }, [FeedbackPage, showAddFeedbackModal]);

  // addActionColumn - useEffect
  useEffect(() => {
    let postsArray = JSON.parse(JSON.stringify(allFeedbackList));
    let newArray = [];
    postsArray.map((item, index) => {
      item.index = <div>{index + 1}</div>;

      item.action = (
        <div className="d-flex">
          <button
            type="button"
            className="btn btn-sm btn-default mx-1"
            title="Edit"
            data-toggle="tooltip"
            data-placement="top"
            onClick={() => {
              setmodalType(1);
              setShowAddFeedbackModal(true);
              setSelectedRow(item);
            }}
          >
            <i className="fa fa-pencil-square-o"></i>
          </button>
          <button
            type="button"
            className="btn btn-sm btn-default "
            title="Delete"
            data-toggle="tooltip"
            data-placement="top"
            onClick={() => {
              deleteFeedback(item.id);
            }}
          >
            <i className="icon-trash"> </i>
          </button>
        </div>
      );

      newArray.push(item);
    });
    setAllFeedbackForRender(newArray);
    setAllFeedbackTableBody(newArray);
  }, [allFeedbackList]);

  const getFeedbackList = () => {
    // setAllFeedbackList([{ name: "adsk", score: "12", id: 12 }]);

    axios({
      method: "GET",
      url: `${baseUrl}/feedback/get-all/branch/${userDetails.bid}`,
      headers: {
        Authorization: token,
      },
    })
      .then((res) => {
        let data = res.data.data;
        setAllFeedbackList(data);
      })
      .catch((error) => {
        console.log(error);

        if (error.response !== undefined) {
          toast.remove();
          toast.error(error.response.data.message, {
            position: "bottom-center",
          });
        } else {
          toast.remove();
          toast.error("Something went wrong", {
            position: "bottom-center",
          });
        }
      });
  };

  //search in table filter - function
  const filter = (e) => {
    const keyword = e.target.value;

    if (keyword !== "") {
      const results = allFeedbackForRender.filter((cat) => {
        return cat.name
          .toString()
          .toLowerCase()
          .includes(keyword.toLowerCase());
      });
      setAllFeedbackTableBody(results);
    } else {
      setAllFeedbackTableBody(allFeedbackForRender);
    }

    setSearchFeedbackText(keyword);
  };

  const deleteFeedback = (id) => {
    Swal.fire({
      position: "center",
      text: "Do you want to delete this feedback?",
      showConfirmButton: true,
      confirmButtonText: "Yes",
      showCancelButton: true,
      cancelButtonText: "No",
      width: "400px",
    }).then((result) => {
      if (result.value == true) {
        axios({
          method: "POST",
          url: `${baseUrl}/feedback/${id}/delete`,
          headers: {
            Authorization: token,
          },
        })
          .then((res) => {
            toast.success("Deleted successfully", {
              position: "bottom-center",
            });
            getFeedbackList();
          })
          .catch((error) => {
            console.log(error);

            if (error.response !== undefined) {
              toast.error(error.response.data.message, {
                position: "bottom-center",
              });
            } else {
              toast.error("Something went wrong", {
                position: "bottom-center",
              });
            }
          });
      }
    });
  };

  return (
    <>
      <div>
        <Toaster />
      </div>
      <div className="container-fluid">
        <div className="block-header">
          <div className="row clearfix">
            <div className="col-md-6 col-sm-12">
              <h1>Feedback</h1>
            </div>

            <div className="col-md-6 col-sm-12 text-right hidden-xs">
              <div
                className="btn btn-sm btn-primary mr-1"
                title="Add New Category"
                onClick={() => {
                  setmodalType(0);
                  setShowAddFeedbackModal(true);
                }}
              >
                Add New
              </div>
            </div>
          </div>
        </div>

        {/* {userDetails.userType === 3 ? ( */}
        <>
          <div className="row clearfix">
            <div className="col-md-12">
              <div className="card">
                <div className="body">
                  <div className="row">
                    <div className="col-lg-3 col-md-6">
                      <div className="input-group header-counter-center">
                        <h5 className="mb-0">
                          {allFeedbackTableBody !== null &&
                          allFeedbackList !== null ? (
                            <>
                              {allFeedbackTableBody.length !== null &&
                              allFeedbackList.length !== null ? (
                                <>
                                  {searchFeedbackText.length > 0
                                    ? `${allFeedbackTableBody.length} / `
                                    : ""}
                                  <small className="text-muted">
                                    {" "}
                                    {allFeedbackList.length}
                                  </small>
                                </>
                              ) : (
                                <></>
                              )}
                            </>
                          ) : (
                            <></>
                          )}
                        </h5>
                      </div>
                    </div>

                    <div className="col-lg-4 col-md-6">
                      <div className="input-group"></div>
                    </div>

                    <div className="col-lg-5 col-md-6 ">
                      <div className="input-group">
                        <input
                          value={searchFeedbackText}
                          onChange={filter}
                          type="text"
                          className="form-control"
                          placeholder="Search here..."
                        />

                        <div className="input-group-append">
                          <button
                            className="btn btn-outline-secondary"
                            type="button"
                          >
                            <i className="fa fa-search" />
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="row clearfix">
            <div className="col-lg-12">
              <div className="card">
                <div className="body">
                  <div className="table-responsive">
                    <MDBDataTable
                      noBottomColumns
                      className="table table-hover js-basic-example dataTable table-custom spacing5 action-col-align categories-table stop-overflow-x stop-table-col-overflow emoji-lg"
                      displayEntries={false}
                      searching={false}
                      paging
                      pagesAmount={15}
                      entries={10} 
                      data={tableData}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      </div>

      <AddFeedbackModal
        showAddFeedbackModal={showAddFeedbackModal}
        modalType={modalType}
        setShowAddFeedbackModal={setShowAddFeedbackModal}
        selectedRow={selectedRow}
        setSelectedRow={setSelectedRow}
      />
    </>
  );
};
export default FeedbackPage;
